import { render, staticRenderFns } from "./entity-validationflows.vue?vue&type=template&id=6a21c85c"
import script from "./entity-validationflows.vue?vue&type=script&lang=js"
export * from "./entity-validationflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports